import React from 'react'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import { useMount, useWindowSize } from 'react-use'
import PoweredBySIAP from './PoweredBySIAP.png'
import { HamburgerMenu, SlidingMenu } from './SlidingMenu'
import { Flex } from './Flex'
import { Text } from './Text'
import { useAuth } from '../../Provider/AuthProvider'
import { useMenuItems, usePageTitle } from '../../Services/MenuConfig'
import { InputSwitch } from 'primereact/inputswitch'
import { cap } from '../../State'

export const TopMenu = () => {
  const { width } = useWindowSize()
  const { onLogout, user: userObj = {} } = useAuth()
  const { user = {} } = userObj || {}
  const { user: { society } = {} } = user || {}
  const title = usePageTitle()
  const navigate = useNavigate()
  const menuItems = useMenuItems(user)
  const [darkMode, setDarkMode] = cap.darkMode.useState()
  const { SINGLE_THEME } = window._env_
  useMount(() => {
    const iconSettings = document.querySelectorAll('.p-inputswitch-slider .icon')
    if (SINGLE_THEME === 'false') {
      iconSettings.forEach((icon) => icon.remove())
      const iconSettingsBefore = document.querySelector('.p-inputswitch-slider')
      const icon1 = document.createElement('div')
      icon1.classList.add('icon', 'pi-moon', 'pi-fw', 'pi')
      icon1.style.fontSize = '16px'
      icon1.style.marginLeft = '2px'
      iconSettingsBefore.appendChild(icon1)
      const icon2 = document.createElement('div')
      icon2.classList.add('icon', 'pi-sun', 'pi-fw', 'pi')
      icon2.style.fontSize = '16px'
      icon2.style.marginRight = '2px'
      icon2.style.color = 'orange'
      iconSettingsBefore.appendChild(icon2)
    }
  })

  const menuAction = (page) => page === 'logout' ? onLogout() : navigate(page)

  return (
    <>
      <SlidingMenu menuAction={menuAction} menuItems={menuItems} />
      <motion.div style={styles.containerStyle} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1 }} className='top-menu'>
        <Flex js row fw>
          <HamburgerMenu />
          <Text title bold size='20px' style={{ marginLeft: 20 }} value={title} />
        </Flex>
        <Flex row fw je>
          {SINGLE_THEME === 'false' ? <InputSwitch id='theme-switch' checked={darkMode} onChange={(e) => setDarkMode(e.value)} style={{ marginRight: 10 }} /> : ''}
          {width > 1240 && <Text bold title size='20px' style={{ marginRight: 20, whiteSpace: 'nowrap' }} value={society || ''} />}
          <img src={PoweredBySIAP} style={{ maxHeight: 46, margin: 2, marginRight: 10 }} />
        </Flex>
      </motion.div>
    </>
  )
}
const styles = {
  containerStyle: {
    width: '100%',
    height: 50,
    zIndex: 50,
    position: 'absolute',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingLeft: 20,
    boxShadow: '0px 2px 2px rgba(100, 100, 100, 0.5)',
    backdropFilter: 'blur(4px) saturate(180%)',
    WebkitBackdropFilter: 'blur(4px) saturate(180%)',
    y: -50,
    opacity: 0
  }
}
